import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Spin } from 'antd';
import styled from 'styled-components';

export const Spinner = styled(Spin)`
  p {
    font-weight: ${FONT_WEIGHT.regular};
  }
`;
